import React from 'react';
import {useListView} from "./ListViewProvider.tsx";

function SelectionHeader({tableProps}) {
  const {isAllSelected, onSelectAll} = useListView()
  const {key, ...props} = tableProps.column.getHeaderProps()
  return (
    <th key={key} {...props} className='w-10px pe-2'>
      <div className='form-check form-check-sm form-check-custom form-check-solid me-3'>
        <input
          className='form-check-input'
          type='checkbox'
          data-kt-check={isAllSelected}
          data-kt-check-target='#kt_table_users .form-check-input'
          checked={isAllSelected}
          onChange={onSelectAll}
        />
      </div>
    </th>
  );
}

export default SelectionHeader;
